import { css, keyframes } from '@emotion/react';

export const slideIn = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
  
  100% {
    transform: translateY(0);
  }
`;

export const slideInAnimation = (time?: number) => css`
  animation: ${slideIn} ${time || 1.5}s cubic-bezier(0.4, 0, 0.2, 1);
`;
